import { updateField } from 'vuex-map-fields'

const SET_CONTACTS = (state, payload) => {
  state.contacts = payload
}

const SET_CONTACT = (state, payload) => {
  state.contact = payload
}

const SET_PW_RESET_TICKET = (state, payload) => {
  state.contact.pwResetTicket = payload
}

const SET_CONTACTROLES = (state, payload) => {
  state.contactRoles = payload
}

const PUSH_CONTACT_ROLE = (state, payload) => {
  state.contact.contactRoles.push(payload)
}

const CONCAT_CONTACT_ROLES = (state, payload) => {
  state.contact.contactRoles = state.contact.contactRoles.concat(payload)
}

const SET_MASSUPDATE_CONTACTROLES = (state, payload) => {
  state.contact.contactRoles = payload
}

const SPLICE_CONTACT_ROLE = (state, id) => {
  let index = state.contact.contactRoles.findIndex(x => x.id === id)
  state.contact.contactRoles.splice(index, 1)
}

const SPLICE_NEW_CONTACT_ROLE = (state, index) => {
  state.contact.contactRoles.splice(index, 1)
}

export default {
  updateField,
  SET_CONTACTS,
  SET_CONTACT,
  SET_PW_RESET_TICKET,
  SET_CONTACTROLES,
  PUSH_CONTACT_ROLE,
  SPLICE_CONTACT_ROLE,
  SPLICE_NEW_CONTACT_ROLE,
  CONCAT_CONTACT_ROLES,
  SET_MASSUPDATE_CONTACTROLES
}
